import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-ta-process',
  templateUrl: './ta-process.component.html',
  styleUrls: ['./ta-process.component.scss']
})
export class TaProcessComponent implements OnInit {

  @Input() done: boolean;
  @Input() name: string;
  @Input() starttime: string;
  @Input() endtime: string;

  @Input() isSla: boolean;

  constructor() { }

  ngOnInit() {
  }

}
